var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { content: _vm.$t("common.columnSettings"), placement: "top" } },
    [
      _c(
        "el-popover",
        { attrs: { width: "200", "popper-class": "columnSetting-popover" } },
        [
          _c("el-link", {
            attrs: {
              slot: "reference",
              icon: "icon-ym icon-ym-options Weforsys-common-head-icon",
              underline: false,
            },
            slot: "reference",
          }),
          _c(
            "Weforsys-table",
            {
              ref: "columnTable",
              staticClass: "columnTable",
              attrs: { data: _vm.data, hasNO: false, size: "mini" },
              on: {
                "selection-change": _vm.columnSelectionChange,
                "row-click": _vm.handleRowClick,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "label",
                  label: "列表字段",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  type: "selection",
                  width: "50",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }